<span [class.via-locations]="isVia">
  @if (location.buildingName && location.buildingName !== location.streetAndNumber) {
    {{ location.buildingName }}
  }
  @if (location.streetAndNumber) {
    {{ location.streetAndNumber }},
  }
  @if (location.town && location.town !== location.streetAndNumber) {
    {{ location.town }},
  }
  {{ location.countryCode }}, {{ location.postcode }}
</span>
